import { get } from "lodash-es";
import { createContext, useEffect, useState } from "react";
import { ReactNode, useContext } from "react";
import { useParams } from "react-router-dom";
import { useComplexState } from "use-complex-state";
import { getLastHeat } from "../../../meltshop/repositories/HeatRepository";
import { ChemistryByHeatReducer } from "./ChemistryByHeatReducer";

const ChemistryByHeatContext = createContext({
	state: ChemistryByHeatReducer.getInitialState(),
	actions: ChemistryByHeatReducer.actions,
});

export const useChemistryByHeatContext = () =>
	useContext(ChemistryByHeatContext);

export const ChemistryByHeatProvider = ({
	children,
}: {
	children: ReactNode;
}) => {
	const [state, actions] = useComplexState({
		initialState: ChemistryByHeatReducer.getInitialState(),
		reducers: ChemistryByHeatReducer.caseReducers,
		name: "ChemistryByHeat",
	});
	const GetLastHeatFromAPI = async () => {
		const resp = await getLastHeat();
		if (resp.ok) {
			const heatName = get(resp, "data.tables[0].rows[0].Name", "");
			if (heatName) {
				actions.setSearchHeatNameText(heatName);
			}
		} else {
			console.log("something happened!");
		}
	};

	const urlParameters = useParams();
	const [heatNameParam] = useState(
		urlParameters.heatName === undefined ? "" : urlParameters.heatName,
	);
	const [validParam] = useState(
		urlParameters.valid === undefined ? true : urlParameters.valid === "true",
	);

	useEffect(() => {
		(async () => {
			if (state.heat === null && heatNameParam === "") {
				await GetLastHeatFromAPI();
			} else if (state.heat === null || state.heat?.Name !== heatNameParam) {
				actions.setSearchHeatNameText(heatNameParam);
			}

			if (state.showOnlyValid !== validParam)
				actions.setShowOnlyValid(validParam);
		})();
	}, [heatNameParam, validParam]);
	return (
		<ChemistryByHeatContext.Provider value={{ state, actions }}>
			{children}
		</ChemistryByHeatContext.Provider>
	);
};
